import InfiniteScroll from "react-infinite-scroll-component"
import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner } from "@/components/shared"
import { GoBack } from "@/components/shared/layout"
import { getAllSaveAffiliates } from "@/features/jobs/affiliates/api/affiliate.api"
import { AffiliateItem, AffiliateItemSkeleton } from "@/features/jobs/affiliates/components/affiliate-item"
import { useInfiniteScrollQuery } from "@/modules/helpers/hooks"
import type { Affiliate } from "@/modules/types"

const AffiliateSavedPage = () => {
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage, forceRefetch } =
    useInfiniteScrollQuery({
      queryKey: ["affiliate-saved"],
      queryFn: getAllSaveAffiliates,
      params: {
        take: 100,
        page: 1
      }
    })

  const campaigns = data?.list || []

  return (
    <div className="flex flex-col h-full bg-white">
      <GoBack title="Đã lưu" className="bg-white" />
      <div className="flex-1 px-4 pt-4 pb-20 overflow-y-auto" id="scrollable">
        <PullToRefresh
          onRefresh={async () => {
            await forceRefetch()
          }}
          pullingContent=""
          refreshingContent={<LoadingSpinner className="w-10 h-10" />}
        >
          <div className="grid grid-cols-2 gap-4">
            {isLoading && !isFetchingNextPage ? (
              Array.from({ length: 6 }).map((_, index) => <AffiliateItemSkeleton key={index} />)
            ) : campaigns.length > 0 ? (
              <InfiniteScroll
                dataLength={campaigns.length}
                next={fetchNextPage}
                hasMore={hasNextPage}
                loader={<LoadingSpinner className="w-10 h-10" />}
                scrollableTarget="scrollable"
                className="grid grid-cols-2 gap-4 col-span-2"
              >
                {campaigns.map((item: Affiliate) => (
                  <AffiliateItem key={item.id} data={item} />
                ))}
              </InfiniteScroll>
            ) : (
              <div className="text-center text-gray-400 col-span-2 mt-10">
                Chưa có sản phẩm nào được lưu
              </div>
            )}
          </div>
        </PullToRefresh>
      </div>
    </div>
  )
}

export default AffiliateSavedPage
